export default __webpack_public_path__ + "static/media/go_back_gray.af0afa9b.svg";